export default __webpack_public_path__ + "static/media/flayer3.8e6bde1b.jpg";